import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import axios from 'axios';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import CpdMessage from './CpdMessage';
import GeneratedFileList from './GeneratedFileList';
import QuickFixBanner from './QuickFixBanner';
import { withQuickFixModal } from './QuickFixModal';
import Icon from '../../../components/Icon';
import { IS_APP_CODEAC } from '../../../constants/env';
import filterProps from '../../../utils/filterProps';
import toolRuleLinker from '../../../utils/tool-rule-linker';
import ISSUE_DOCS from '../../../../temp/issues.json';
const ISSUE_EXPANSION_ENABLED = IS_APP_CODEAC;
class Issue extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            docsLoading: false,
            docsExpanded: false,
            docs: '',
        };
        this.handleToggleDocs = (event, tool, ruleId) => {
            if (event) {
                event.preventDefault();
            }
            if (!this.state.docs) {
                this.setState((prevState) => {
                    return {
                        docsExpanded: !prevState.docsExpanded,
                        docsLoading: true,
                    };
                }, () => this._loadDocs(`${tool}/${ruleId.replace('@typescript-eslint', 'typescript-eslint').replaceAll(' ', '')}`));
            }
            else {
                this.setState((prevState) => {
                    return {
                        docsExpanded: !prevState.docsExpanded,
                    };
                });
            }
            if (this.props.onIssueExpandClick) {
                this.props.onIssueExpandClick(this.state.docsExpanded);
            }
        };
        this.handleScrollToLine = (event, target) => {
            event.preventDefault();
            let element = document.getElementById(target);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
            else {
                target = target.replace(/:[0-9]+/, '');
                element = document.getElementById(target);
                if (element) {
                    // @todo: maybe automatically load not-loaded file?
                    element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            }
        };
    }
    _loadDocs(docsPath) {
        return axios
            .get(`/issues/${docsPath}.html`)
            .then((response) => {
            this.setState({
                docsLoading: false,
                docs: response.data,
            });
        })
            .catch((error) => {
            console.error(error);
        });
    }
    renderReference(href, showDocs, ruleId, tool) {
        if (!href) {
            return _jsx("span", { className: "report-detail__reference", children: ruleId });
        }
        const hasExtendedDocs = ISSUE_DOCS.includes(`${tool}/${ruleId.replace('@typescript-eslint', 'typescript-eslint').replaceAll(' ', '')}`);
        if (hasExtendedDocs && ISSUE_EXPANSION_ENABLED) {
            return (_jsxs("a", { href: "#", target: "_blank", className: "report-detail__reference", onClick: (event) => this.handleToggleDocs(event, tool, ruleId), children: [ruleId, "\u00A0", _jsx("span", { className: clsx('issue__expand', showDocs && 'issue__expand--open') })] }));
        }
        return (_jsx("a", { href: href, target: "_blank", rel: "noreferrer", className: "report-detail__reference", children: ruleId }));
    }
    renderMessage(tool, message, ruleId, options, handleShowDetails, extension, quickFix) {
        const { t } = this.props;
        const showQuickFix = quickFix && options && handleShowDetails;
        if (['cpd', 'phpcpd', 'jscpd'].includes(tool)) {
            return _jsx(CpdMessage, { message: message, handleScrollToLine: this.handleScrollToLine });
        }
        else if (tool === t('siteName').toLowerCase() && ruleId === 'GeneratedFiles') {
            return _jsx(GeneratedFileList, { options: options });
        }
        else if (showQuickFix) {
            return _jsx(QuickFixBanner, { options: options, extension: extension, handleShowDetails: handleShowDetails });
        }
        return message;
    }
    renderDocs(href, ruleId, tool, toolVersion) {
        const { t } = this.props;
        return (_jsxs("div", { className: "issue__docs", children: [_jsx("h6", { className: "issue__docs-title", children: t('issueWhy') }), this.state.docsLoading ? (t('loading')) : (_jsx("div", { dangerouslySetInnerHTML: {
                        __html: this.state.docs,
                    } })), _jsx("h6", { className: "issue__docs-title", children: t('issueFurtherRead') }), _jsx("p", { children: _jsxs("a", { className: "issue__docs__reference", href: href, target: "_blank", rel: "noreferrer", children: [_jsx(Icon, { name: "info-circle-o" }), " \u00A0 ", ruleId] }) }), _jsxs("small", { className: "text-muted", children: [t('poweredBy'), " ", tool, " ", toolVersion] })] }));
    }
    render() {
        const { issue, extension, onShowDetailsClick, ...rest } = filterProps(this.props, [
            'onIssueExpandClick',
            'i18n',
            'lng',
            't',
            'tReady',
        ]);
        const { isError, tool, toolVersion, ruleId, message, quickFix, options, nodeType } = issue;
        const plugin = issue.ruleId ? issue.ruleId.split('/') : '';
        const showDocs = this.state.docsExpanded || this.state.docsLoading;
        const href = toolRuleLinker(tool, toolVersion, ruleId || '', nodeType || '', 
        // @ts-expect-error TS2345: Argument of type 'string[] | ""' is not assignable to parameter of type 'string[] | null | undefined'.
        plugin.length !== 1 ? plugin : [], options);
        const hasReference = ruleId && !(tool === 'sass-lint' && ruleId === 'Fatal');
        const issueMessage = this.renderMessage(tool, message, ruleId, 
        // @ts-expect-error TS2345: Argument of type 'any[] | { files: string[]; } | undefined' is not assignable to parameter of type 'Record<string, any>'.
        options, onShowDetailsClick, quickFix, extension);
        const iconName = isError ? 'exclamation-circle' : 'exclamation-triangle';
        const iconColor = isError ? 'text-danger' : 'text-warning';
        const iconClasses = clsx('issue__icon', quickFix ? 'icon--info-circle-o text-info' : `icon--${iconName} ${iconColor}`);
        return (_jsxs("div", { ...rest, children: [_jsx("span", { className: iconClasses }), hasReference ? this.renderReference(href, showDocs, ruleId, tool) : null, _jsx("span", { className: "report-detail__message", children: issueMessage }), showDocs ? this.renderDocs(href, ruleId, tool, toolVersion) : null] }));
    }
}
export default withQuickFixModal(withTranslation()(Issue));
